import React, { useCallback } from "react";
import { Accordion } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./Step.styles";
import { Summary } from "./Summary";
import { Control } from "./Control";
import { Actions } from "./Actions";
import { useDimensionItemsQuery } from "../../../api";
import { useLCID } from "../../../../locale";
import { HiddenControl } from "./HiddenControl";
import type { IStepProps } from "./Step.types";
import { useBulkExportContext } from "../../../providers";
import { DimensionType } from "../../../types";
import cn from "classnames";

export const Step: FC<IStepProps> = (props) => {
  const classes = useStyles();
  const context = useBulkExportContext();
  const lcid = useLCID();
  const {
    visible,
    index,
    allSteps,
    name,
    identifier,
    hierarchyIdentifier,
    open,
    onToggle,
    onChangeStep,
    type,
    item,
    isSavedBulk,
    bulkId,
    favoriteBulkItemByQuery,
    isSubscriptionBulk,
  } = props;

  const isBulkFavourite = Boolean(bulkId);

  const dataSourceId = bulkId ? bulkId : context?.state.dataSourceId!;
  const { dimensionItems } = useDimensionItemsQuery(lcid, dataSourceId, identifier);

  const handleToggle = useCallback(() => onToggle?.(hierarchyIdentifier), [onToggle, hierarchyIdentifier]);
  if ((!visible && dimensionItems === undefined) || isSavedBulk) {
    return null;
  }

  if (
    (isSubscriptionBulk || isBulkFavourite) &&
    ![
      DimensionType.Hierarchy,
      DimensionType.Configuration,
      DimensionType.Frequency,
      DimensionType.BaseIndexAnnual,
      DimensionType.BaseIndexAQMW,
      DimensionType.BaseIndexAQM,
      !isBulkFavourite ? DimensionType.DynamicDateRangeAQMW : null,
      !isBulkFavourite ? DimensionType.DynamicDateRangeAQM : null,
      !isBulkFavourite ? DimensionType.DynamicDateRangeAnnual : null,
      !isBulkFavourite ? DimensionType.DynamicDateRangeWeek : null,
      !isBulkFavourite ? DimensionType.DynamicDateRangeAQMWD : null,
    ].includes(type)
  ) {
    return null;
  }

  if (!visible && dimensionItems !== undefined) {
    return <HiddenControl hierarchyIdentifier={hierarchyIdentifier} items={dimensionItems} />;
  }

  return (
    <Accordion
      expanded={open}
      onChange={handleToggle}
      className={cn(classes.panel, {
        [classes.hiddenPanel]:
          isSubscriptionBulk &&
          [
            DimensionType.DynamicDateRangeAQMW,
            DimensionType.DynamicDateRangeAQM,
            DimensionType.DynamicDateRangeAnnual,
            DimensionType.DynamicDateRangeWeek,
            DimensionType.DynamicDateRangeAQMWD,
          ].includes(type),
      })}
    >
      <Summary
        type={type}
        hierarchyIdentifier={hierarchyIdentifier}
        items={dimensionItems}
        name={name}
        open={open}
        item={item}
        favoriteBulkItemByQuery={favoriteBulkItemByQuery}
      />
      <Control
        hierarchyIdentifier={hierarchyIdentifier}
        allSteps={allSteps}
        type={type}
        items={dimensionItems}
        item={item}
        bulkId={bulkId}
        favoriteBulkItemByQuery={favoriteBulkItemByQuery}
        isSubscriptionBulk={isSubscriptionBulk}
      />
      <Actions
        index={index}
        onChangeStep={onChangeStep}
        allSteps={allSteps}
        isBulkFavourite={isBulkFavourite}
        isBulkSubscibtion={isSubscriptionBulk}
      />
    </Accordion>
  );
};
